import { Dialog } from '@mui/material';

/**
 * FS dialog shell — the design-system replacement for raw MUI <Dialog>.
 * Chrome (24px radius card, shadow) comes from .fs-dialog in src/styles/dialog.scss.
 * Compose with FsDialogHeader / FsDialogBody / FsDialogFooter.
 */
export const FsDialog = ({
	state,
	onClose,
	children,
	maxWidth = 'lg',
	width = null,
	fullWidth = true,
	preventOutsideClick = false,
	testId = '',
	className = '',
	paperClassName = '',
	paperStyle = {},
	onPaperScroll,
}) => {
	return (
		<Dialog
			data-testid={testId}
			className={`fs-dialog z-[99999999] ${className}`}
			PaperProps={{
				style: { ...(width && { width }), ...paperStyle },
				className: paperClassName,
				onScroll: (e) => {
					onPaperScroll && onPaperScroll(e);
				},
			}}
			disableEscapeKeyDown={preventOutsideClick}
			maxWidth={maxWidth}
			fullWidth={fullWidth}
			open={state}
			onClose={(e, reason) => {
				if (preventOutsideClick && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
					e.stopPropagation();
					return;
				}
				onClose && onClose(false);
			}}>
			{children}
		</Dialog>
	);
};
